var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton-body"},_vm._l((parseInt(_vm.lines, 10)),function(l){return _c('div',{key:l,staticClass:"skeleton-body__line",class:_vm.getSize})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }